import { render } from "./ProfesionalDetalle.vue?vue&type=template&id=622b1ca2&ts=true"
import script from "./ProfesionalDetalle.vue?vue&type=script&lang=ts"
export * from "./ProfesionalDetalle.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/front-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__